import { useQuery, UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { FilterOptionsUser, useFilterUsers as useFilterUsersClient, useGetUserById, User } from './Users';
import { getStaleTimeInMinutes } from '@/shared/utils/staleTime.ts';

// To account for permission changes the stale time is lower
const STALE_TIME = getStaleTimeInMinutes(5);

export function useFilterUsers(filterOptions: FilterOptionsUser) {
    const { filterUsers } = useFilterUsersClient();

    return useQuery({
        queryKey: ['users', filterOptions],
        queryFn: () => filterUsers(filterOptions),
        staleTime: STALE_TIME,
    });
}

export function useUser(id?: number | null, options?: Omit<UseQueryOptions<User>, 'queryKey' | 'queryFn' | 'enabled'>) {
    const { getUserById } = useGetUserById();

    return useQuery({
        queryKey: ['user', id!],
        queryFn: () => getUserById(id!),
        enabled: !!id,
        refetchOnWindowFocus: false,
        staleTime: STALE_TIME,
        ...options,
    });
}

export function useUserSuspenseQuery(id: number) {
    const { getUserById } = useGetUserById();

    return useSuspenseQuery({
        queryKey: ['user', id],
        queryFn: () => getUserById(id),
        refetchOnWindowFocus: false,
        staleTime: STALE_TIME,
    });
}
